import React from 'react';
import PhoneNumberInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';

const PhoneInput = ({
  id,
  name,
  label,
  placeholder = "Numéro de téléphone",
  value,
  onChange,
  required = false,
  disabled = false,
  errors = {}
}) => {
  // Gérer le changement de numéro avec react-phone-number-input
  const handlePhoneChange = (phoneValue) => {
    const event = {
      target: {
        name: name,
        value: phoneValue || ''
      }
    };
    onChange(event);
  };

  return (
    <div className="space-y-2">
      <label className="block text-sm font-medium text-gray-700">
        {label} {required && <span className="text-orange-500">*</span>}
      </label>

      <div className={`phone-input-wrapper ${errors[name] ? 'error' : ''} ${disabled ? 'disabled' : ''}`}>
        <PhoneNumberInput
          id={id}
          placeholder={placeholder}
          value={value || ''}
          onChange={handlePhoneChange}
          disabled={disabled}
          defaultCountry="FR"
          addInternationalOption={false}
          international={false}
          withCountryCallingCode={true}
          countrySelectProps={{
            disabled: disabled
          }}
          inputProps={{
            autoComplete: 'tel',
            className: `phone-number-input ${errors[name] ? 'error' : ''} ${disabled ? 'disabled' : ''}`
          }}
        />
      </div>

      {errors[name] && (
        <p className="mt-1 text-sm text-orange-600">{errors[name]}</p>
      )}

      <style jsx>{`
        .phone-input-wrapper {
          width: 100%;
        }

        .phone-input-wrapper :global(.PhoneInput) {
          display: flex;
          align-items: center;
          border: 1px solid #d1d5db;
          border-radius: 0.5rem;
          padding: 0.75rem 1rem;
          background-color: white;
          transition: all 0.2s;
          box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
        }

        .phone-input-wrapper :global(.PhoneInput:focus-within) {
          outline: none;
          ring: 2px;
          ring-color: #3b82f6;
          border-color: transparent;
        }

        .phone-input-wrapper.error :global(.PhoneInput) {
          border-color: #fed7aa;
          background-color: #fef3f2;
          ring-color: #fb923c;
        }

        .phone-input-wrapper.disabled :global(.PhoneInput) {
          border-color: #e5e7eb;
          background-color: #f9fafb;
          cursor: not-allowed;
        }

        .phone-input-wrapper :global(.PhoneInputCountrySelect) {
          margin-right: 0.5rem;
          border: none;
          background: transparent;
          font-size: 1rem;
          cursor: pointer;
        }

        .phone-input-wrapper.disabled :global(.PhoneInputCountrySelect) {
          cursor: not-allowed;
          color: #6b7280;
        }

        .phone-input-wrapper :global(.PhoneInputInput) {
          border: none;
          outline: none;
          flex: 1;
          font-size: 1rem;
          background: transparent;
          color: #111827;
        }

        .phone-input-wrapper :global(.PhoneInputInput::placeholder) {
          color: #9ca3af;
        }

        .phone-input-wrapper.disabled :global(.PhoneInputInput) {
          color: #6b7280;
          cursor: not-allowed;
        }

        .phone-input-wrapper :global(.PhoneInputCountryIcon) {
          width: 1.25rem;
          height: 1.25rem;
          margin-right: 0.25rem;
        }
      `}</style>
    </div>
  );
};

export default PhoneInput;